export const getOAuthUrl = () => {
  const baseUrl = import.meta.env.VITE_OAUTH_URL
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: import.meta.env.VITE_CLIENT_ID,
    redirect_uri: import.meta.env.VITE_OAUTH_REDIRECT_URI,
    scope: import.meta.env.VITE_SCOPE
  })

  return `${baseUrl}?${params}`
}
